import React ,{Component } from 'react';
import PatientCertRequest from '../views/patientcertrequest';
import { physicianActions, patientActions,certrequestActions,certificationReferenceActions,certificationTypeActions,certificationTypeGroupActions } from "../../actions";
import { connect } from 'react-redux';
import { objConstants} from '../../constants/obj.constants'
import { history } from '../../helpers';
import { withRouter } from "react-router-dom";

class PatientCertRequestContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isNextStep:false
         }
       
    }
    
   
    

    componentDidMount(){
       

       const {patientId}=this.props.match.params;

       console.log('Props',this.props);

       const { dispatch } = this.props;   

        if (patientId) {

            let id = patientId;
             
            dispatch(patientActions.get(id));     
        
        } 
      
    }

    render() { 

        const { type,obj,items } = this.props;
        console.log('Items',items);
        if(type==objConstants.ADD_SUCCESS)
        {
           // console.log('Added successfully');
           // history.push('/certrequest/payment/'+obj.Id)
        }
      
     
        return ( 
            <PatientCertRequest model={this.props.obj}  certTypeList={(items!=null && items.certTypes!=null)?items.certTypes:null} {...this.props}  ref="child" />
         );
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items,error } = state.objs;
    
   //console.log('STATE',state)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items,
        error
      
        
    };
} 

export default withRouter(connect(mapStateToProps)(PatientCertRequestContainer));